<div class="flex items-center max-w-sm">
  <select
    id="countries"
    [(ngModel)]="selectedLanguageCodeId"
    (change)="onSelect($event)"
    class="text-sm rounded-lg border block p-2.5 min-w-25 bg-amazone-gray placeholder-gray-400 text-white font-medium focus:ring-amazone-orange focus:border-amazone-orange cursor-pointer"
  >
    @for (language of languages; track $index) {
      <option [ngClass]="{ 'font-bold': language.main }" value="{{ language.languageCodeId }}">
        {{ language.main ? '★ ' : '' }}{{ language.languageCodeId }}
      </option>
    }
  </select>
</div>
